import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Swiper, SwiperSlide } from 'swiper/react'
import * as queryString from 'query-string'

import {
	CreateAccountProgressbar,
	PredictionsProgressbar,
	UseFeatureProgressbar,
} from '../../components/processing'
import {
	getFlowType,
	getIsLegalFlow,
	getUserId,
} from '../../redux/slices/userSlice'
import { paramsToQuery } from '../../utils/historyDecorators'
import { getUpsellPrice, getInitialPrice } from '../../redux/slices/configSlice'

import './styles.scss'

const ProcessingScreen = () => {
	const history = useHistory()
	const params = queryString.parse(location.search)

	const flow_type = useSelector(getFlowType)
	const isLegalFlow = useSelector(getIsLegalFlow)

	const [isActive, setIsActive] = useState(false)
	const [progress, setProgress] = useState(0)
	const user_id = useSelector(getUserId)
	const upsell_test = params?.upsell_test || useSelector(getUpsellPrice)
	const initial_price = params?.initial_price || useSelector(getInitialPrice)

	useEffect(() => {
		if (progress > 66 && progress <= 99) {
			setTimeout(() => {
				setProgress(progress + 1)
			}, 75)
			return
		}
		if (progress > 33 && progress <= 66) {
			setTimeout(() => {
				setProgress(progress + 1)
			}, 100)
			return
		}
		if (progress <= 33) {
			setTimeout(() => {
				setProgress(progress + 1)
			}, 50)
			return
		}

		setTimeout(() => setIsActive(false), 1500)
		setTimeout(
			() =>
				history.push({
					pathname: '/email',
					search: isLegalFlow
						? paramsToQuery({ user_id, external_id: user_id })
						: paramsToQuery({
								user_id,
								external_id: user_id,
								upsell_test,
								initial_price,
						  }),
				}),
			1850,
		)
	}, [progress])

	useEffect(() => {
		setTimeout(() => {
			setIsActive(true)
		}, 350)
	}, [])

	switch (flow_type) {
		case '1':
		case '5':
		case '9': {
			return (
				<div
					className={`processing processing--features ${
						isActive ? 'processing--active' : ''
					}`}
				>
					<UseFeatureProgressbar progress={progress} />
					<div className="processing-tooltip">
						<span className="processing-tooltip__title">
							Your data is secured
						</span>
						<span className="processing-tooltip__description">
							Photos and videos aren&apos;t stored on the cloud
						</span>
					</div>
				</div>
			)
		}
		case '2': {
			return (
				<div className={`processing ${isActive ? 'processing--active' : ''}`}>
					<CreateAccountProgressbar progress={progress} />
					<Swiper
						allowTouchMove={false}
						slidesPerView={1}
						speed={1500}
						centeredSlides={true}
						className="slider"
						autoplay={{
							delay: 5300,
							disableOnInteraction: false,
							stopOnLastSlide: true,
						}}
					>
						<SwiperSlide>
							<div className="slide">
								<h1 className="processing-title">One of the best</h1>
								<p className="processing-subtitle">Entertainment apps</p>
								<img src="/images/processing/rating.png" alt="rating" />
							</div>
						</SwiperSlide>
						<SwiperSlide>
							<div className="slide">
								<h1 className="processing-title"> 2 mln people</h1>
								<p className="processing-subtitle">
									Opt for Reface, are you in?
								</p>
								<img src="/images/processing/people.png" alt="people" />
							</div>
						</SwiperSlide>
					</Swiper>
				</div>
			)
		}
		case '3':
		case '4':
		case '6':
		case '10': {
			return (
				<div className={`processing ${isActive ? 'processing--active' : ''}`}>
					<PredictionsProgressbar progress={progress} />
				</div>
			)
		}

		default: {
			return <p>no component</p>
		}
	}
}

export { ProcessingScreen }
